var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "j-modal",
    {
      staticClass: "j-super-query-modal",
      staticStyle: { top: "5%", "max-height": "95%" },
      attrs: {
        width: 600,
        visible: _vm.visible,
        mask: true,
        fullscreen: _vm.izMobile,
        footer: null,
      },
      on: { cancel: _vm.handleCancel },
    },
    [
      _c(
        "div",
        {
          staticStyle: { "font-size": "16px", "font-weight": "600" },
          attrs: { slot: "title" },
          slot: "title",
        },
        [_vm._v("处理详情")]
      ),
      _c(
        "div",
        [
          _vm.detailList.length
            ? _vm._l(_vm.detailList, function (item, index) {
                return _c("div", { key: index, staticClass: "list-item" }, [
                  _c("div", { staticClass: "left-area" }, [
                    _c("span", { staticStyle: { "font-weight": "bold" } }, [
                      _vm._v(_vm._s(item.name)),
                    ]),
                    _c("span", { staticStyle: { "margin-top": "6px" } }, [
                      _vm._v(_vm._s(item.comment)),
                    ]),
                  ]),
                  _c("div", [_vm._v(_vm._s(item.createTime))]),
                ])
              })
            : _c(
                "div",
                {
                  staticStyle: {
                    padding: "40px 0",
                    "text-align": "center",
                    "font-size": "18px",
                    color: "#ccc",
                  },
                },
                [_vm._v("\n      暂无数据\n    ")]
              ),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }